if (!window.EcoScentCaseStudiesTemplate) {
  window.EcoScentCaseStudiesTemplate = {
    sectionSelector: '.case-studies-template-section',
    railSelector: '.case-studies-template-nav-inner',

    makeRailDraggable: function (rail) {
      let isDragging = false;
      let dragStartX = 0;
      let dragStartScrollLeft = 0;

      rail.addEventListener('mousedown', function (event) {
        isDragging = true;
        dragStartX = event.pageX - rail.offsetLeft;
        dragStartScrollLeft = rail.scrollLeft;
        rail.style.cursor = 'grabbing';
      });

      document.addEventListener('mouseup', function () {
        isDragging = false;
        rail.style.cursor = '';
      });

      rail.addEventListener('mousemove', function (event) {
        if (!isDragging) return;
        event.preventDefault();
        const pointerX = event.pageX - rail.offsetLeft;
        rail.scrollLeft = dragStartScrollLeft - (pointerX - dragStartX);
      });
    },

    initSection: function (section) {
      const namespace = window.EcoScentCaseStudiesTemplate;
      if (section.dataset.caseStudiesTemplateReady === 'true') return;

      const rail = section.querySelector(namespace.railSelector);
      if (!rail) return;

      section.dataset.caseStudiesTemplateReady = 'true';
      namespace.makeRailDraggable(rail);
    },

    initAllSections: function (root) {
      const namespace = window.EcoScentCaseStudiesTemplate;
      (root || document).querySelectorAll(namespace.sectionSelector).forEach(namespace.initSection);
    },

    handleSectionLoad: function (event) {
      window.EcoScentCaseStudiesTemplate.initAllSections(event.target);
    },

    listen: function () {
      const namespace = window.EcoScentCaseStudiesTemplate;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { namespace.initAllSections(); });
      } else {
        namespace.initAllSections();
      }
      document.addEventListener('shopify:section:load', namespace.handleSectionLoad);
    },
  };

  window.EcoScentCaseStudiesTemplate.listen();
}
